/*!
 * ============================================================================
 * SHOP-001 · Selector Inteligente de Variantes — Aceitunas López
 * ----------------------------------------------------------------------------
 * Versión : 2.1.0
 * Fecha   : 2026-08-05
 * Tema    : aceitunaslopez.es desarrollado por inspireagency (Glozin 3.0.0)
 * Archivo : assets/aceitunas-smart-variants.js
 *
 * QUÉ HACE
 *   Dentro del selector de variantes del tema (<variant-radios-detail>):
 *     · Oculta las combinaciones de opciones que NO EXISTEN.
 *     · Marca (sin ocultar) las que existen pero están AGOTADAS.
 *     · Si la opción seleccionada deja de ser posible, salta a la primera
 *       válida y avisa al tema con un evento 'change' real.
 *
 *   Funciona con 1, 2 o 3 opciones y NO depende del nombre de la opción
 *   ("Tamaño", "Material", "Formato"...). Usa la posición real que Shopify
 *   asigna en product.options_with_values, leída del orden del DOM dentro
 *   del propio selector.
 *
 * EVENTO PÚBLICO
 *   En cada cambio de variante emite, con burbujeo hasta document:
 *
 *     document.addEventListener('aceitunas:variantchange', function (e) {
 *       e.detail.variant    // objeto variante de Shopify, o null si no existe
 *       e.detail.options    // ['400g', 'Vidrio']
 *       e.detail.available  // true | false
 *       e.detail.price      // precio en céntimos, o null
 *       e.detail.root       // el <variant-radios-detail> afectado
 *     });
 *
 *   Ese evento es el punto de enganche para SHOP-002 (precio por kilo),
 *   SHOP-003 (badges), la ficha técnica, etc. Ningún componente futuro
 *   debería volver a tocar este archivo.
 *
 * QUÉ NO HACE (a propósito)
 *   · No cambia el diseño de los swatches. El diseño es del tema.
 *   · No toca precio, imágenes, carrito ni URL. De eso ya se encarga el tema.
 *   · No pinta el estado "agotado" ni escribe la clase .option-disabled.
 *     Eso ya lo hace el tema en vivo (theme.js → updateVariantStatuses), y
 *     dos componentes escribiendo la misma clase acabarían peleándose.
 *     SHOP-001 solo añade lo que faltaba: ocultar lo que NO EXISTE.
 *
 * DEPURACIÓN
 *   window.ACEITUNAS_DEBUG = true;  // antes de cargar la página
 * ============================================================================
 */
(function () {
  'use strict';

  var NS = '[SHOP-001]';
  var ROOT_SELECTOR = 'variant-radios-detail, variant-radios-single, variant-group-detail';
  var CLS_HIDDEN = 'shop001-hidden';
  var CLS_UNAVAILABLE = 'shop001-unavailable';

  function debug() {
    if (!window.ACEITUNAS_DEBUG) return;
    try {
      console.log.apply(console, [NS].concat(Array.prototype.slice.call(arguments)));
    } catch (e) {}
  }

  function escapeId(value) {
    if (window.CSS && typeof window.CSS.escape === 'function') return window.CSS.escape(value);
    return String(value).replace(/([^\w-])/g, '\\$1');
  }

  /* --------------------------------------------------------------------------
   * Devuelve el elemento VISIBLE que corresponde a un radio.
   * En este tema el <input> está oculto y lo que se ve es su <label>, que es
   * un HERMANO, no un ancestro. Por eso se busca por el atributo for=.
   * ------------------------------------------------------------------------ */
  function controlFor(input, scope) {
    var wrapper = input.closest ? input.closest('swatch-dropdown-item') : null;
    if (wrapper) return wrapper;

    if (input.id) {
      var byFor = (scope || document).querySelector('label[for="' + escapeId(input.id) + '"]');
      if (byFor) return byFor;
    }

    var next = input.nextElementSibling;
    while (next) {
      if (next.tagName === 'LABEL') return next;
      if (next.tagName === 'INPUT') break;
      next = next.nextElementSibling;
    }
    return null;
  }

  /* ========================================================================
   * Componente
   * ====================================================================== */
  function SmartVariants(root) {
    this.root = root;
    this.busy = false;
    this.lastKey = null;

    this.variants = this.readVariants();
    this.groups = this.readGroups();

    if (!this.variants || !this.variants.length) {
      debug('Sin datos de variantes. No se activa.', root);
      return;
    }
    if (!this.groups.length) {
      debug('Sin grupos de opciones. No se activa.', root);
      return;
    }

    var expected = (this.variants[0].options || []).length;
    if (this.groups.length !== expected) {
      console.warn(
        NS,
        'Los grupos del DOM (' + this.groups.length + ') no coinciden con las opciones del producto (' + expected + ').',
        'No se activa para no romper el selector.',
        root
      );
      this.groups = [];
      return;
    }

    this.root.classList.add('shop001-ready');
    this.bind();
    this.refresh();
    debug('Activo con ' + this.groups.length + ' opción(es) y ' + this.variants.length + ' variantes.', root);
  }

  /* --- Datos ------------------------------------------------------------ */

  SmartVariants.prototype.readVariants = function () {
    var local = this.root.querySelector('script[type="application/json"]');
    if (local) {
      try {
        var parsed = JSON.parse(local.textContent);
        if (Array.isArray(parsed) && parsed.length) return parsed;
      } catch (e) {
        debug('JSON local ilegible.', e);
      }
    }
    var global = document.querySelector('[data-product-json]');
    if (global) {
      try {
        var product = JSON.parse(global.textContent);
        if (product && product.variants && product.variants.length) return product.variants;
      } catch (e) {
        debug('data-product-json ilegible.', e);
      }
    }
    return null;
  };

  SmartVariants.prototype.readGroups = function () {
    var out = [];
    var fieldsets = this.root.querySelectorAll('fieldset');
    for (var i = 0; i < fieldsets.length; i++) {
      var inputs = fieldsets[i].querySelectorAll('input[type="radio"]');
      if (!inputs.length) continue;
      out.push({ el: fieldsets[i], inputs: inputs });
    }
    return out;
  };

  /* --- Estado ----------------------------------------------------------- */

  SmartVariants.prototype.selection = function () {
    var sel = [];
    for (var i = 0; i < this.groups.length; i++) {
      var checked = this.groups[i].el.querySelector('input[type="radio"]:checked');
      sel.push(checked ? checked.value : null);
    }
    return sel;
  };

  // ¿La variante encaja con lo ya elegido en los grupos anteriores a `upTo`?
  SmartVariants.prototype.matchesPrefix = function (variant, sel, upTo) {
    for (var i = 0; i < upTo; i++) {
      if (sel[i] === null || sel[i] === undefined) continue;
      if (variant.options[i] !== sel[i]) return false;
    }
    return true;
  };

  SmartVariants.prototype.currentVariant = function () {
    var sel = this.selection();
    for (var i = 0; i < this.variants.length; i++) {
      var v = this.variants[i];
      var ok = true;
      for (var j = 0; j < sel.length; j++) {
        if (sel[j] === null || v.options[j] !== sel[j]) { ok = false; break; }
      }
      if (ok) return v;
    }
    return null;
  };

  /* --- Motor ------------------------------------------------------------ */

  SmartVariants.prototype.refresh = function () {
    if (!this.groups.length) return;

    for (var g = 0; g < this.groups.length; g++) {
      var sel = this.selection(); // se relee: un grupo puede haber cambiado el anterior
      var group = this.groups[g];
      var inputs = group.inputs;
      var checkedWasHidden = false;
      var firstUsable = null;
      var firstExisting = null;

      for (var i = 0; i < inputs.length; i++) {
        var input = inputs[i];
        var exists = false;
        var inStock = false;

        for (var v = 0; v < this.variants.length; v++) {
          var variant = this.variants[v];
          if (variant.options[g] !== input.value) continue;
          if (!this.matchesPrefix(variant, sel, g)) continue;
          exists = true;
          if (variant.available) { inStock = true; break; }
        }

        var control = controlFor(input, group.el);

        if (control) {
          control.classList.toggle(CLS_HIDDEN, !exists);
          control.classList.toggle(CLS_UNAVAILABLE, exists && !inStock);
        }
        // El input se deja SIEMPRE habilitado: quien decide si una combinación
        // se puede comprar es el tema/Shopify, no este componente.
        input.setAttribute('aria-hidden', exists ? 'false' : 'true');

        if (exists && !firstExisting) firstExisting = input;
        if (exists && inStock && !firstUsable) firstUsable = input;
        if (input.checked && !exists) checkedWasHidden = true;
      }

      if (checkedWasHidden) {
        var fallback = firstUsable || firstExisting;
        if (fallback) {
          debug('La opción elegida del grupo ' + (g + 1) + ' ya no es posible. Saltando a "' + fallback.value + '".');
          this.busy = true;
          fallback.checked = true;
          fallback.dispatchEvent(new Event('change', { bubbles: true }));
          this.busy = false;
        }
      }
    }

    this.emit();
  };

  SmartVariants.prototype.emit = function () {
    var variant = this.currentVariant();
    var options = this.selection();
    var key = (variant ? variant.id : 'none') + '|' + options.join('~');
    if (key === this.lastKey) return;
    this.lastKey = key;

    var detail = {
      variant: variant,
      variantId: variant ? variant.id : null,
      options: options,
      available: !!(variant && variant.available),
      price: variant ? variant.price : null,
      root: this.root
    };

    debug('aceitunas:variantchange', detail);
    this.root.dispatchEvent(new CustomEvent('aceitunas:variantchange', {
      bubbles: true,
      detail: detail
    }));
  };

  SmartVariants.prototype.bind = function () {
    var self = this;
    this.root.addEventListener('change', function (e) {
      if (self.busy) return;
      var t = e.target;
      if (!t || t.tagName !== 'INPUT' || t.type !== 'radio') return;
      self.refresh();
    });
  };

  /* ========================================================================
   * Arranque
   * ====================================================================== */
  var instances = [];

  function init(scope) {
    var roots = (scope || document).querySelectorAll(ROOT_SELECTOR);
    for (var i = 0; i < roots.length; i++) {
      if (roots[i].__shop001) continue;
      roots[i].__shop001 = true;
      instances.push(new SmartVariants(roots[i]));
    }
  }

  function boot() {
    try {
      init(document);
    } catch (e) {
      console.warn(NS, 'Error al iniciar:', e);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // El editor de temas de Shopify vuelve a pintar las secciones al vuelo.
  document.addEventListener('shopify:section:load', function (e) {
    try { init(e.target); } catch (err) { console.warn(NS, err); }
  });

  window.AceitunasSmartVariants = { init: init, instances: instances };
})();
